import { render, staticRenderFns } from "./ContactPeople.vue?vue&type=template&id=7cd20be9&"
import script from "./ContactPeople.vue?vue&type=script&lang=js&"
export * from "./ContactPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports